<p>
  <mat-toolbar color="primary">
  <span class = "title">Katamix</span>
  <span class="example-spacer"></span>
  <button *ngIf="this.authService.isLoggedIn()" mat-raised-button routerLink="/register"  >Regisztrálás</button>
  <div class="divider"></div>
  <button *ngIf="this.authService.isLoggedIn()" mat-raised-button (click)="logOut()">Kijelentkezés</button>
</mat-toolbar>
</p>
<router-outlet></router-outlet>